import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  RedeemActionSlice,
  RedeemActionRejectSlice,
  RedeemRequestSlice,
  setFilters,
  setPage,
  setRowsPerPage,
} from "../redux/slices/RedeemRequests";
import DownloadTable from "./widgets/downloaddata";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Snackbar,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RefreshIcon from "@mui/icons-material/Refresh";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { keyframes } from "@emotion/react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import moment from "moment";
import autoTable from "jspdf-autotable";
import { exportToExcel, exportToPdf, exportToWord } from "../utils/exportUtils";
import DownloadData from "./widgets/downloaddata";
import DoneIcon from "@mui/icons-material/Done";
import { ablyClient, RedeemChannel } from "../lib/socket";
import LazyTable from "./widgets/lazytable";
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RedeemRequest = () => {
  const dispatch = useDispatch();
  const { page, data, rowsPerPage, totalRedeems, loading, filters } =
    useSelector((state) => state.redeem);
  const [submittingIndex, setSubmittingIndex] = useState(null);

  const fetchRedeemRequests = () => {
    dispatch(RedeemRequestSlice(page, rowsPerPage, filters));
  };
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopySnackbar(true);
    });
  };

  useEffect(() => {
    fetchRedeemRequests();
  }, [dispatch, page, rowsPerPage, filters]);

  // Dummy data for testing

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [copySnackbar, setCopySnackbar] = useState(false);
  const userData = useSelector((state) => state.login.user);
  const headers = [
    "#",
    "User Name",
    "Game ID",
    "Current Balance",
    "Redeem Amount",
    "Date",
    "Status",
  ];
  const statusTextMap = (rowData) => {
    let color, statusText; // Removed 'icon'
    const status = (param) =>
      rowData.bl.filter((va, i, m) => m.includes(param));

    if (status(4)?.length) {
      color = "#FFC107";
      statusText = "Pending";
    } else if (status(2)?.length) {
      color = "#4CAF50";
      statusText = "Approved";
    } else if (status(10)?.length) {
      color = "red";
      statusText = "Rejected";
    }

    // Return an object containing only color and statusText
    return { color, statusText };
  };
  const tableData = data?.map((row, index) => [
    index + 1,
    row.name,
    row.username,
    `$${row.balance}`,
    row.radeem,
    moment(row?.createdAt).format("L"),
    statusTextMap(row).statusText,
  ]);

  const statusBodyTemplate = (rowData) => {
    let color, icon, statusText;
    const status = (param) =>
      rowData.bl.filter((va, i, m) => m.includes(param));

    if (status(4)?.length) {
      color = "#FFC107";
      statusText = "Pending";
      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else if (status(2)?.length) {
      color = "#4CAF50";
      statusText = "Approved";

      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else if (status(10)?.length) {
      color = "red";
      statusText = "Rejected";

      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    }

    return (
      <div className="flex justify-start items-center">
        <Box
          className="mr-2"
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
        {status(2)?.length
          ? "Done"
          : status(10)?.length
          ? "Rejected"
          : "Pending"}
      </div>
    );
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(event.target.value, 10));
    dispatch(setPage(0));
  };

  const handleApprove = async (params, index) => {
    setSubmittingIndex(params?._id);
    const payload = {
      ghid: params?._id,
      uid: params?.user_id,
      aid: userData?.id,
      uname: userData?.name,
      gameid: params?.gameid,
    };
    dispatch(RedeemActionSlice(payload));
    setSubmittingIndex(null);
    await RedeemChannel(
      "admin-redeem",
      params?._id,
      "admin-456",
      "private-redeem"
    );
  };
  useEffect(() => {
    const channel = ablyClient.channels.get("admin-redeem");

    const messageHandler = async (message) => {
      const { senderId, receiverId, text } = message.data;

      if (senderId) {
        // setMessages((prev) => [...prev, { senderId, receiverId, text }]);
        fetchRedeemRequests();
      }
    };

    channel.subscribe("private-redeem", messageHandler);

    return () => {
      channel.unsubscribe("private-redeem", messageHandler);
    };
  }, [dispatch]);
  const handleReject = async (params, index) => {
    setSubmittingIndex(params?._id);
    const payload = {
      ghid: params?._id,
      uid: params?.user_id,
      aid: userData?.id,
      uname: userData?.name,
      gameid: params?.gameid,
    };
    await dispatch(RedeemActionRejectSlice(payload));
    setSubmittingIndex(null);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ flexGrow: 1, display: "flex", alignItems: "center", gap: 2 }}
        >
          <Typography variant="h5">Redeem Request</Typography>
          <IconButton
            onClick={fetchRedeemRequests}
            disabled={loading}
            sx={{
              animation: loading ? `${rotate} 1s linear infinite` : "none",
              backgroundColor: "#3f51b5",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
        <DownloadData
          headers={headers || []}
          tableData={tableData || []}
          fileName={"Redeem-requests"}
        />

        <Snackbar
          open={copySnackbar}
          autoHideDuration={3000}
          message="Copied to clipboard!"
          onClose={() => setCopySnackbar(false)}
        />
      </Box>
      <Typography
        sx={{
          color: "#3f51b5",
          mb: 3,
        }}
      >
        Process redeem requests by verifying user-initiated transfers from game
        accounts to wallet balances.
      </Typography>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Please select an export format."
        onClose={() => setOpenSnackbar(false)}
      />

      <Snackbar
        open={copySnackbar}
        autoHideDuration={3000}
        message="Copied to clipboard!"
        onClose={() => setCopySnackbar(false)}
      />

      <LazyTable
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRedeems}
        loading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onFilterChange={(filters) => {
          dispatch(setFilters(filters));
        }}
        columns={[
          { field: "name", headerName: "User Name", filter: true },
          {
            field: "gameid",
            headerName: "GameID",
            filter: true,
            render: (rowData) => (
              <Box display="flex" alignItems="center" gap={1}>
                <Typography>{rowData.username}</Typography>
                <IconButton
                  size="small"
                  onClick={() => handleCopy(rowData.username)}
                  sx={{ padding: 0 }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Box>
            ),
          },
          {
            field: "balance",
            headerName: "Current Balance",
            filter: true,
          },
          {
            field: "radeem",
            headerName: "Radeem Amount",
            filter: true,
            render: (rowData) => `$${rowData?.radeem}`,
          },
          {
            field: "createdAt",
            headerName: "Date",
            filter: true,
            render: (rowData) => moment(rowData?.createdAt).format("L LT"),
          },
          {
            field: "active",
            headerName: "Status",
            filter: true,
            render: statusBodyTemplate,
          },
          {
            field: "actions",
            headerName: "Actions",
            render: (rowData, index) => {
              const status = rowData.bl.filter((va, i, m) => m.includes(4));
              if (rowData._id === submittingIndex) {
                return <CircularProgress size={20} />;
              }
              if (status.length > 0) {
                return (
                  <Box display="flex" gap={1}>
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      onClick={() => handleApprove(rowData, index)}
                      // disabled={LoadingIndex === index ? true : false}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleReject(rowData, index)}
                      // disabled={LoadingIndex === index ? true : false}
                    >
                      Reject
                    </Button>
                  </Box>
                );
              }
            },
          },
        ]}
      />

      {/* <DataTable
        value={RedeemRequest?.data}
        paginator
        rows={10}
        showGridlines
        stripedRows
        tableStyle={{
          minWidth: "50rem",
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
        className="p-datatable-sm"
        filterDisplay="menu"
      >
        <Column
          field="name"
          header="Username"
          filter
          filterPlaceholder="Search by Username"
        />
        <Column
          header="Game ID"
          body={(rowData) => (
            <Box display="flex" alignItems="center" gap={1}>
              <Typography>{rowData.username}</Typography>
              <IconButton
                size="small"
                onClick={() => handleCopy(rowData.username)}
                sx={{ padding: 0 }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
          filter
          filterPlaceholder="Search by Game ID"
        />

        <Column
          field="balance"
          header="Curr Balance"
          filter
          filterPlaceholder="Search by Balance"
          body={(rowData) => `$${rowData?.balance}`}
        />
        <Column
          field="radeem"
          header="Radeem Amount"
          filter
          filterPlaceholder="Search by Balance"
          body={(rowData) => `$${rowData?.radeem}`}
        />
        <Column
          field="date"
          header="Date"
          filter
          filterPlaceholder="Search by Date"
          body={(rowData) => moment(rowData?.createdAt).format("L")}
        />
        <Column body={statusBodyTemplate} header="Status" />
        <Column
          body={(rowData, index) => {
            const status = rowData.bl.filter((va, i, m) => m.includes(4));
            if (status.length > 0) {
              return (
                <Box display="flex" gap={1}>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => handleApprove(rowData, index)}
                    disabled={LoadingIndex === index ? true : false}
                  >
                    {LoadingIndex === index ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Approve"
                    )}
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleReject(rowData, index)}
                    disabled={LoadingIndex === index ? true : false}
                  >
                    {LoadingIndex === index ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Reject"
                    )}
                  </Button>
                </Box>
              );
            }
          }}
          header="Actions"
        />
      </DataTable> */}
    </>
  );
};

export default RedeemRequest;
